// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + "b121c413" + ".chunk.css");